/** ----------------------------------------
    Dropdown Option Multiple
 ---------------------------------------- */

function dropdownOption(obj, active) {
    let html = `
         <div class="dropdown__option">
            <input type="checkbox" id="${ obj.value }" ${ active }>
            <label for="${ obj.value }">${ obj.name }</label>
        </div>
    `;

    return html;
}

/** ----------------------------------------
    Dropdown Option Single
 ---------------------------------------- */

function dropdownOptionSingle(obj, name, index) {
    let html = `
         <div class="dropdown__option">
            <input type="radio" id="${ obj.value }" name="${ name }" ${ index === 0 ? 'checked' : '' }>
            <label for="${ obj.value }">${ obj.name }</label>
        </div>
    `;

    return html;
}

/** ----------------------------------------
    Dropdown Select
 ---------------------------------------- */

function selectedOption(obj, index, selected = 0) {
    let html = `
        <div class="dropdown__select ${ index === selected || obj.name === selected ? 'is-active' : '' }" id="${ obj.value }" data-ticket="${ obj.ticket }" data-text="${obj.text}">${ obj.name }</div>
    `;

    return html;
}

/** ----------------------------------------
    Export Templates
 ---------------------------------------- */

export {
    dropdownOption,
    dropdownOptionSingle,
    selectedOption
}